<template>
  <v-app>
    <div
      class="back"
      style="position: fixed; height: 100vh; width: 100vw;"
    >
      <v-container
        id="fundo"
        class="p-0 fill-height"
        fluid
      >
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        >
          <v-col
            cols="11"
            sm="8"
            md="5"
            lg="4"
            xl="3"
            style="padding: 0px"
          >
            <v-container class="fill-height">
              <v-container
                :class="($vuetify.breakpoint.xs ? 'mb-auto' : 'mb-auto mt-10')"
                :style="($vuetify.breakpoint.xs ? 'padding: 4px;' : 'width: 400px;')"
              >
                <v-container class="pb-4">
                  <v-row
                    class="layout-logos-login fill-height px-4 height"
                    align="center"
                    justify="center"
                  >
                    <v-img
                      src="@/assets/logo_branca.png"
                      height="200px"
                      contain
                      style="top: -80px;"
                    />
                  </v-row>
                </v-container>
                <div>
                  <v-card
                    color="white"
                    style="padding: 12px; top: -80px;"
                  >
                    <v-card-text style="height: auto;">
                      <v-text-field
                        v-model="resetEmail"
                        prepend-inner-icon="mdi-account"
                        validate-on-blur
                        style="margin-bottom: 18px; top: 10%;"
                        label="Digite o seu email ou CPF/CNPJ"
                        outlined
                        autocomplete="new-password"
                        dense
                        filled
                        :disabled="this.resetEmailMessage"
                      />

                      <div
                        v-if="this.resetEmailMessage"
                      >
                        <div style="color: #757575; text-align: center;">
                          <p>
                            Enviamos um e-mail para você. A mensagem deve chegar dentro de alguns minutos na sua caixa de entrada.
                            Caso não a encontre, verifique também sua pasta de spam.
                          </p>
                          <p style="color: #144682; font-weight: bold;">
                            Tente novamente em: {{ this.timeRemaining }}
                          </p>
                        </div>
                      </div>
                    </v-card-text>

                    <v-card-actions>
                      <v-row>
                        <v-btn
                          text
                          :class="$vuetify.breakpoint.xs ? 'mt-1' : 'mr-auto'"
                          @click="login"
                        >
                          Cancelar
                        </v-btn>
                        <v-btn
                          color="primary"
                          :disabled="this.resetEmailMessage"
                          :class="$vuetify.breakpoint.xs ? 'mt-1' : 'ml-auto'"
                          @click="recoverEmail"
                        >
                          Recuperar
                        </v-btn>
                      </v-row>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-container>
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <img
      style="max-height: 160px; max-width: 160px;position: fixed; bottom: 10px; right: 10px; z-index: 1;"
      src="@/assets/esteio/powered_by_horizontal_p.png"
      contain
    >
  </v-app>
</template>
<script>
  export default {
    data () {
      return {
        timeRemaining: null,
        changePassword: false,
        resetEmail: null,
        resetEmailMessage: false,
      }
    },
    mounted () {
      this.verificaTempoRestante()
    },
    methods: {
      verificaTempoRestante () {
        if (localStorage.getItem('user')) {
          const infoUser = JSON.parse(localStorage.getItem('user'))
          const tempoRestanteSegundos = infoUser.timer
          this.resetEmail = infoUser.email
          this.startTimer(tempoRestanteSegundos, this.timeRemaining)
          this.resetEmailMessage = !this.resetEmailMessage
          localStorage.removeItem('user')
        }
      },
      login () {
        if (this.timeRemaining) {
          this.saveTimer(this.timeRemaining)
        }
        this.$router.push('/login')
      },
      saveTimer (time) {
        const [minutes, seconds] = time.split(':').map(Number)
        const timeRemainingSeconds = minutes * 60 + seconds

        const user = {
          email: this.resetEmail,
          timer: timeRemainingSeconds,
        }

        localStorage.setItem('user', JSON.stringify(user))
      },
      startTimer (duration, display) {
        let time = duration; let minutes; let seconds
        const interval = setInterval(() => {
          minutes = parseInt(time / 60, 10)
          seconds = parseInt(time % 60, 10)

          minutes = minutes < 10 ? '0' + minutes : minutes
          seconds = seconds < 10 ? '0' + seconds : seconds
          this.timeRemaining = minutes + ':' + seconds

          if (--time < 0) {
            clearInterval(interval)
            this.timeRemaining = null
            this.resetEmailMessage = !this.resetEmailMessage
          }
        }, 1000)
      },
      recoverEmail () {
        return this.api.forgotPassword(this.resetEmail).then(
          data => {
            this.resetEmailMessage = !this.resetEmailMessage
            this.startTimer(120, this.timeRemaining)
            this.Swal.fire(
              'E-mail enviado',
              'E-mail com link para alteração de senha enviado!',
              'success',
            )
          },
          error => {
            this.Swal.fire({
              icon: 'error',
              title: 'Insira um e-mail válido!',
              text: error.message,
            })
          },
        )
      },
      passwordForgot () {
        this.changePassword = !this.changePassword
      },
    },
  }
</script>

<style lang="css" scoped>

.v-btn, .v-card, .v-text-field {
    border-radius: 8px;
}
.back {
  background-color: #173148;
  /* background-image: url('../../assets/loginimage.png'); */
  background-size: cover;
}

</style>
